import React, { useRef } from 'react';
import './Eras.scss';
import EraIntro from './EraIntro/EraIntro';
import ApolloJoints from './Parts/Joints/ApolloJoints';
import ApolloGloves from './Parts/Gloves/ApolloGloves';
import ApolloBoots from './Parts/Boots/ApolloBoots';
import ArtemisGloves from './Parts/Gloves/ArtemisGloves';
import ContemporaryGloves from './Parts/Gloves/ContemporaryGloves';
import ContemporaryBoots from './Parts/Boots/ContemporaryBoots';
import FutureGloves from './Parts/Gloves/FutureGloves';
import ArtemisBoots from './Parts/Boots/ArtemisBoots';
import FutureBoots from './Parts/Boots/FutureBoots';
import ContemporaryTorso from './Parts/Torso/ContemporaryTorso';
import ContemporaryJoints from './Parts/Joints/ContemporaryJoints';
import ArtemisJoints from './Parts/Joints/ArtemisJoints';
import FutureJoints from './Parts/Joints/FutureJoints';
import ArtemisTorso from './Parts/Torso/ArtemisTorso';
import FutureTorso from './Parts/Torso/FutureTorso';
import ApolloHelmet from './Parts/Helmet/ApolloHelmet';
import FutureHelmet from './Parts/Helmet/FutureHelmet';
import ContemporaryHelmet from './Parts/Helmet/ContemporaryHelmet';
import ArtemisHelmet from './Parts/Helmet/ArtemisHelmet';
import ApolloTorso from './Parts/Torso/ApolloTorso';
import CTA from '../Common/CTA/CTA';

function Eras({ screenWidth, screenHeight, currentEra }) {
  const erasRef = useRef();

  const eraData = [
    {
      index: 0,
      id: 'apolloEra',
      era: 'The Apollo Era',
      years: '1961-1972',
      copy: [
        "The golden era of space exploration, when man first stepped on the moon. Although these suits were hand-sewn by women — professional seamstresses who contributed their expertise to the project — they were all worn by men. The suit used for Apollo Mission 11 was called the A7L. That plus a life support system made up what's called an EMU, or “Extravehicular Mobility Unit,” a pressurized garment that allows the wearer to perform moon or other spacewalks."
      ]
    },
    {
      index: 1,
      id: 'contemporaryEra',
      era: 'The Contemporary Era',
      years: '1980s-Today',
      copy: [
        "Since the Apollo program, space flights have become more routine, with astronauts from all over the world focusing their work on the International Space Station. Today’s main suit, used since the early '80s and updated in 2002, is known simply as the “EMU.” As diversity among astronauts has increased, it has begun to show some shortcomings, including a shortage of components that can fit smaller women."
      ]
    },
    {
      index: 2,
      id: 'artemisEra',
      era: 'The Artemis Era',
      years: '2025-Beyond',
      copy: [
        "In support of upcoming missions, NASA has hired private contractors to develop a new suit meant to fit more people with greater ease. NASA's own prototype for this suit, which they will continue to develop through the end of 2022, is called the xEMU, or “Exploration Extravehicular Mobility Unit.” They aim to debut an updated suit in 2025, when the first woman and the first person of color are scheduled to walk on the moon."
      ]
    },
    {
      index: 3,
      id: 'theFuture',
      era: 'The Future',
      years: 'The Age of Access',
      copy: [
        'Planning for trips to Mars and beyond, companies and institutions are working on groundbreaking spacesuit designs that rethink everything from fit to pressurization.',
        'To help imagine a more inclusive future in space, Morgan Stanley has partnered with space experts, historians, and designers to create The Access I, a speculative vision of a suit made to fit everyone.'
      ]
    }
  ];

  return (
    <section className="eras" ref={erasRef}>
      <EraIntro eraData={eraData[0]} eras={eraData} currentEra={currentEra} />
      <ApolloHelmet screenWidth={screenWidth} />
      <ApolloTorso />
      <ApolloJoints screenHeight={screenHeight} screenWidth={screenWidth} />
      <ApolloGloves screenWidth={screenWidth} />
      <ApolloBoots />
      <EraIntro eraData={eraData[1]} eras={eraData} currentEra={currentEra} />
      <ContemporaryHelmet screenWidth={screenWidth} />
      <ContemporaryTorso screenWidth={screenWidth} />
      <ContemporaryJoints screenWidth={screenWidth} />
      <ContemporaryGloves />
      <ContemporaryBoots />
      <EraIntro eraData={eraData[2]} eras={eraData} currentEra={currentEra} />
      <ArtemisHelmet screenWidth={screenWidth} />
      <ArtemisTorso screenWidth={screenWidth} />
      <ArtemisJoints screenWidth={screenWidth} />
      <ArtemisGloves screenWidth={screenWidth} />
      <ArtemisBoots screenWidth={screenWidth} />
      <EraIntro eraData={eraData[3]} eras={eraData} currentEra={currentEra} />
      <FutureHelmet screenWidth={screenWidth} />
      <FutureTorso screenWidth={screenWidth} />
      <FutureJoints screenWidth={screenWidth} />
      <FutureGloves screenWidth={screenWidth} />
      <FutureBoots screenWidth={screenWidth} />
      <div className="eras__animationContainer__cta">
        <CTA origin="intro" />
      </div>
    </section>
  );
}

export default Eras;
